import type { ConceptCategory, ConceptDef } from './types';
import type { ConceptKind } from './kinds';
import { api } from '../api/client';
import type { ProgramView } from '../programs/types';

export const CATEGORY_ORDER: ConceptCategory[] = [
  'Receptive', 'Expressive', 'Echoic', 'Intraverbal', 'Mand',
  'Matching', 'Sorting', 'Sequencing', 'Math', 'Literacy',
  'Motor imitation', 'Social', 'Daily living',
];

export type LibraryDraft = {
  name: string;
  kind: ConceptKind;
  category: ConceptCategory;
  config: Record<string, unknown>;
};

export function draftFromLibrary(c: ConceptDef): LibraryDraft {
  const base = { name: c.label, category: c.category };
  switch (c.kind) {
    case 'tileMatch':
      return {
        ...base,
        kind: c.kind,
        config: {
          promptMode: c.config.promptMode,
          tileCount: c.config.tileCount,
          items: c.config.items.map((i) => ({ say: i.say, answer: i.answer })),
        },
      };
    case 'supervisorScored':
      return {
        ...base,
        kind: c.kind,
        config: {
          promptMode: c.config.promptMode,
          prompts: c.config.prompts.map((p) => ({ ...p })),
        },
      };
    case 'sequenceTap':
      return {
        ...base,
        kind: c.kind,
        config: {
          promptMode: c.config.promptMode,
          sequences: c.config.sequences.map((s) => ({ label: s.label, items: [...s.items] })),
        },
      };
    case 'timerHold':
      return {
        ...base,
        kind: c.kind,
        config: {
          holdSeconds: c.config.holdSeconds,
          rounds: c.config.rounds,
          prompts: [{ prompt: c.config.promptText }],
        },
      };
    default:
      return { ...base, kind: c.kind, config: structuredClone(c.config) };
  }
}

export function addFromLibrary(c: ConceptDef, learnerId: string | null): Promise<ProgramView> {
  const d = draftFromLibrary(c);
  return api<ProgramView>(
    learnerId ? `/programs?learnerId=${encodeURIComponent(learnerId)}` : '/programs',
    { method: 'POST', token: true, body: { ...d, track: 'CURRENT' } },
  );
}
